import './style.scss';
import React, { useRef, useState } from 'react';
import GenericPlaceholder from '../Shared/components/GenericPlaceholder/index.js';
import clsx from 'clsx';
import CardItemsCarousel from './CardItemsCarousel';
import CardItems from './CardItems';
import { RichText, Text, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import CustomCarouselControls from '../Shared/components/CustomCarouselControls';

const CardListingNoCTA = (props) => {
  const [nextDisabled, setNextDisabled] = useState(false);
  const [prevDisabled, setPrevDisabled] = useState(true);
  const swiperRef = useRef();
  if (!props?.fields || !props.params) {
    return <GenericPlaceholder componentName="CardListingNoCTA" />;
  }

  const { fields, params, sitecoreContext } = props;
  const { items } = fields;

  const shouldRenderList = Array.isArray(items) && items.length > 0;
  if (!shouldRenderList) return null;

  const isCarousel = params?.carouselMode === '1';

  const _text = fields?.text;
  const _heading = fields?.heading;
  const shouldRenderTitle = !!_heading && _heading?.value !== '';
  const shouldRenderDescription = !!_text && _text?.value !== '';

  const rightArrow = '/-/media/Project/FAB2/Fab2/data/media/svgs/gallery/icon-arrow-right';
  const leftArrow = '/-/media/Project/FAB2/Fab2/data/media/svgs/gallery/icon-arrow-left';

  return (
    <div
      className={clsx(
        'CardListingNoCTASection',
        isCarousel && 'carousel-layout',
        !isCarousel && 'grid-layout',
        'add-margins',
        props?.params?.Styles
      )}
    >
      <div className="content">
        <div className={clsx('card-listing')}>
          {(shouldRenderTitle || shouldRenderDescription) && (
            <div className="data-wrap">
              {shouldRenderTitle && (
                <div className="data-item-title">
                  <Text field={_heading} />
                </div>
              )}
              {shouldRenderDescription && (
                <RichText className="data-item-description" field={_text} />
              )}
            </div>
          )}

          {!isCarousel && (
            <div className="card-grid-view flex-it flex-wrap">
              <CardItems items={fields?.items} />
            </div>
          )}

          {isCarousel && (
            <div className="swiper-wrap">
              <CustomCarouselControls
                classname="navigation-custom"
                rightArrow={rightArrow}
                leftArrow={leftArrow}
                totalItems={fields?.items?.length}
                nextDisabled={nextDisabled}
                prevDisabled={prevDisabled}
                swiperRef={swiperRef}
              />
              <CardItemsCarousel
                items={fields?.items}
                language={sitecoreContext.language}
                setPrevDisabled={setPrevDisabled}
                setNextDisabled={setNextDisabled}
                swiperRef={swiperRef}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default withSitecoreContext()(CardListingNoCTA);
